import React from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import './title-description.scss';
import ListingStatus from '../listing-status/listing-status';
import Tooltip from '../tooltip/tooltip';

export default function TitleDescription({
  title,
  description,
  tag,
  redireUrl,
  className,
  descriptionLimit,
}) {
  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return `${text.slice(0, maxLength)}...`;
    }
    return text;
  };
  return (
    <div className={`title-description-container ${className}`}>
      <h4 className="title" data-cy="my-company-title">
        {title}
      </h4>

      {tag ? (
        <p className="description">
          <span className="paragraph">{description}</span>{' '}
        </p>
      ) : (
        <>
          {title !== 'Status' && redireUrl ? (
            <p className="description">
              <Link to={redireUrl}>
                <Tooltip content={description}>
                  {ReactHtmlParser(truncateText(description, descriptionLimit))}
                </Tooltip>
              </Link>
            </p>
          ) : (
            title !== 'Status' && (
              <div className="description" data-cy="my-company-description">
                {description !== '' ? (
                  <Tooltip content={description}>
                    {ReactHtmlParser(
                      truncateText(description, descriptionLimit)
                    )}
                  </Tooltip>
                ) : (
                  '--'
                )}
              </div>
            )
          )}
          {title === 'Status' && (
            <ListingStatus statusLabel={description} autoWidth />
          )}
          <span />
        </>
      )}
    </div>
  );
}
TitleDescription.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  tag: PropTypes.bool,
  redireUrl: PropTypes.string,
  className: PropTypes.string,
  descriptionLimit: PropTypes.number,
};
TitleDescription.defaultProps = {
  title: 'Title',
  description: '--',
  tag: false,
  redireUrl: '',
  className: '',
  descriptionLimit: 30,
};
